export default {
  exam: {
    1001: "不限时",
    1002: "单选",
    1003: "多选",
    1004: "上一题",
    1005: "下一题",
    1006: "提交",
    1007: "答对",
    1008: "答错",
    1009: "未答",
    1010: "查看答案",
    1011: "总分",
    1012: "分",
    1013: "正确率",
    1014: "答案",
    1015: "正确答案",
    1016: "您的答案",
    1017: "太棒了，全部答对了！",
    1018: "很遗憾，回答错误，继续努力！",
    1019: "正确",
    1020: "错误",
    1021: "满分",
    1022: "0分",
    1023: "关闭",
    1024: "网络繁忙，请重新作答。",
    1025: "重答",
    1026: "姓名",
    1027: "三方ID",
    1028: "参会ID",
    1029: "身份信息",
  },
  lang: {
    "k_870001": "选项1",
    "k_870002": "选项2",
    "k_870003": "选项",
    "k_871001": "标题名称",
    "k_874001": "图片处理",
    "k_874002": "裁剪",
    "k_874003": "取消裁剪",
    "k_874004": "重新上传",
    "k_874005": "确定",
    "k_874006": "取消",
    "k_876001": "更换",
    "k_876002": "建议尺寸：800*450px，小于4M 支持jpg、gif、png、bmp",
    "k_876003": "上传封面图片只能是 {0} 格式",
    "k_876004": "上传封面图片大小不能超过 4M",
    "k_876005": "图片上传中...",
    "k_877001": "省/自治区/直辖市",
    "k_877002": "市",
    "k_877003": "区/县",
    "k_877004": "请输入详细地址",
    "k_878001": "建议尺寸：*px，小于4M",
    "k_878002": "支持jpg、gif、png、bmp",
    "k_878003": "请输入内容",
    "k_879001": "日期",
    "k_879002": "时间",
    "k_879003": "日期时间",
    "k_880001": "短信验证",
    "k_880002": "已开启，将对手机号进行国内号段校验及验证码验证",
    "k_881001": "建议尺寸：*px，小于4M",
    "k_881002": "支持jpg、gif、png、bmp",
    "k_881003": "请输入内容",
    "k_882001": "隐私协议",
    "k_882002": "展示系统自带协议",
    "k_882003": "预览效果：",
    "k_882004": "提交并同意",
    "k_882005": "《隐私政策》",
    "k_882006": "及",
    "k_882007": "《用户保护协议》",
    "k_882008": "自定义协议",
    "k_882009": "去设置",
    "k_882010": "<a target=\"_blank\" href=\"https://e.vhall.com/v3/privacyUPo\">《隐私声明》</a>保护您所填写的所有信息",
    "k_883001": "隐私协议设置",
    "k_883002": "隐私协议",
    "k_883003": "协议名称",
    "k_883004": "跳转链接",
    "k_883005": "请输入以http://或https://开头的链接",
    "k_883006": "预览效果",
    "k_883007": "确 定",
    "k_883008": "取 消",
    "k_883009": "我们根据《隐私声明》保护您填写的所有信息",
    "k_883010": "《隐私声明》",
    "k_883011": "请输入协议名称",
    "k_883012": "添加隐私协议会超出预览字数，请删减后再添加",
    "k_883013": "《隐私声明2》",
    "k_883014": "{0}和{1}",
    "k_883015": "{0}和",
    "k_883016": "和{0}",
    "k_883017": "请输入正确的网址",
    "k_884001": "省",
    "k_884002": "市",
    "k_884003": "区/县",
    "k_884004": "请输入详细地址",
    "k_885001": "展开",
    "k_885002": "收起",
    "k_886001": "生日",
    "k_887001": "手机号",
    "k_887002": "易盾的占位",
    "k_887003": "动态验证码",
    "k_887004": "发送验证码",
    "k_887005": "请输入手机号",
    "k_887006": "请输入正确的手机号",
    "k_888001": "展开",
    "k_888002": "收起",
    "k_890001": "标题",
    "k_890002": "问卷简介",
    "k_890003": "扩展信息",
    "k_890004": "文本题",
    "k_890005": "请选择您的时间",
    "k_890006": "地区选择题",
    "k_890007": "单选题",
    "k_890008": "选项",
    "k_890009": "多选题",
    "k_890010": "选项1",
    "k_890011": "选项2",
    "k_890012": "选项3",
    "k_890013": "选项4",
    "k_890014": "表格",
    "k_890015": "列1",
    "k_890016": "列2",
    "k_890017": "行1",
    "k_890018": "行2",
    "k_890019": "分页",
    "k_890020": "分割线",
    "k_890021": "图文备注",
    "k_890022": "自定义",
    "k_890023": "最多添加10个选项",
    "k_890024": "行",
    "k_890025": "列",
    "k_891001": "移动",
    "k_891002": "复制",
    "k_891003": "删除",
    "k_891004": "添加选项",
    "k_891005": "选项最多支持26个",
    "k_891006": "点击题型并设置正确答案和分数，创建题目",
    "k_891007": "保存",
    "k_891008": "提示",
    "k_891009": "保存同时共享至资料管理，便于其他活动使用？",
    "k_891010": "共享到资料管理",
    "k_891011": "确 定",
    "k_891012": "取 消",
    "k_891013": "单选",
    "k_891014": "多选",
    "k_891015": "第{0}题未设置正确答案",
    "k_891016": "第{0}题有选项未上传图片",
    "k_891017": "保存成功!",
    "k_891018": "保存失败",
    "k_892001": "题型",
    "k_892002": "文字单选",
    "k_892003": "文字多选",
    "k_892004": "图片单选",
    "k_892005": "图片多选",
    "k_893001": "全局设置",
    "k_893002": "参与答题条件",
    "k_893003": "已开启，当累计观看时长满足设置的时长条件后，观众自动收到答题弹窗参与答题",
    "k_893004": "开启后，当累计观看时长满足设置的时长条件后，观众自动收到答题弹窗参与答题",
    "k_893005": "累计观看",
    "k_893006": "分钟",
    "k_893007": "可参与答题",
    "k_893008": "提示：观看时长达到指定时间即可参与答题，观看时长定义：同一个用户在直播间的累计时长。暂停观看不计算时长；更换浏览器重新计算时长；同一用户多端观看，各端观看时长独立计算，不累加。需要注意：更换观众身份将重新计算观看时长",
    "k_893009": "重新答题机会",
    "k_893010": "已开启，当成绩未满分时，可允许重新作答一次",
    "k_893011": "开启后，当成绩未满分时，可允许重新作答一次",
    "k_893012": "强制填写",
    "k_893013": "已开启，观众未提交答题成功时，将无法关闭答题页面",
    "k_893014": "开启后，观众未提交答题成功时，将无法关闭答题页面",
    "k_893015": "回放填写",
    "k_893016": "已开启，直播中已推送的答题，观看回放时可参与答题",
    "k_893017": "开启后，直播中已推送的答题，观看回放时可参与答题",
    "k_893018": "答题时长",
    "k_893019": "1.开启后，观众需在指定时间内完成答题。答题中途离开后倒计时不会停止，建议提醒观众不要长时间离开答题页面",
    "k_893020": "2.答题计时，以主办方推送时间进行计时",
    "k_893021": "设置时长",
    "k_893022": "秒",
    "k_893023": "需在规定时间内完成答题，超时自动收卷",
    "k_893024": "自动推送成绩排行榜",
    "k_893025": "开启答题限时后，倒计时结束自动推送成绩排行榜至观看端；关闭后需要人工推送",
    "k_893026": "答题时间到期后，自动推送排行榜给观众",
    "k_893027": "显示成绩及答案",
    "k_893028": "默认开启，关闭后观众完成答题不会显示成绩及每道题的答案",
    "k_893029": "题目设置",
    "k_893030": "样式",
    "k_893031": "上图下文",
    "k_893032": "左图右文",
    "k_893033": "布局",
    "k_893034": "单列",
    "k_893035": "双列",
    "k_893036": "分值",
    "k_893037": "分",
    "k_893038": "正确答案 (单选)",
    "k_893039": "正确答案 (多选)",
    "k_893040": "限时单位已修改，请重新设置限时时间",
    "k_894001": "题数",
    "k_894002": "文字单选题",
    "k_894003": "文字多选题",
    "k_894004": "图片单选题",
    "k_894005": "图片多选题",
    "k_894006": "总分",
    "k_895001": "上一页",
    "k_895002": "下一页",
    "k_896001": "问卷",
    "k_896002": "修改已收集数据的问卷，按照修改后的问卷重新统计，为确保问卷统",
    "k_896003": "计结果不受影响，建议已推送的问卷需要修改时可以复制一份新的问卷",
    "k_896004": "创建问卷",
    "k_896005": "资料库",
    "k_896006": "批量删除",
    "k_896007": "请输入问卷名称",
    "k_896008": "您还没有问卷，快来创建吧！",
    "k_896009": "提交",
    "k_896010": "问卷名称",
    "k_896011": "更新时间",
    "k_896012": "题目数量",
    "k_896013": "预览",
    "k_896014": "复制",
    "k_896015": "编辑",
    "k_896016": "删除",
    "k_896017": "当前问卷已被推送，修改将影响之前收集的数据，确认修改?",
    "k_896018": "提示",
    "k_896019": "确定",
    "k_896020": "取消",
    "k_896021": "已取消修改",
    "k_896022": "删除后，此问卷将无法使用，确认删除?",
    "k_896023": "删除成功",
    "k_896024": "删除失败",
    "k_896025": "已取消删除",
    "k_896026": "请选择要操作的选项",
    "k_897001": "答题须知",
    "k_897002": "（非必填）",
    "k_897003": "请输入答题须知",
    "k_897004": "（必填）",
    "k_897005": "必填项",
    "k_897006": "保存",
    "k_897007": "保存成功",
    "k_898001": "开启后，设置用户信息收集表获取准确信息；用户在答题前须填写本表，若有多个答题，只需填写一次",
    "k_898002": "用户信息收集已开启",
    "k_898003": "用户信息收集已关闭",
    "k_899001": "姓名",
    "k_899002": "性别",
    "k_899003": "男",
    "k_899004": "女",
    "k_899005": "生日",
    "k_899006": "手机",
    "k_899007": "邮箱",
    "k_899008": "教育水平",
    "k_899009": "行业",
    "k_899010": "地域",
    "k_899011": "公司",
    "k_899012": "部门",
    "k_899013": "职务",
    "k_899014": "工号",
    "k_900001": "隐私协议设置",
    "k_900002": "隐私协议",
    "k_900003": "协议名称",
    "k_900004": "跳转链接",
    "k_900005": "请输入以http://或https://开头的链接",
    "k_900006": "预览效果",
    "k_900007": "确 定",
    "k_900008": "取 消",
    "k_900009": "我们根据《隐私声明》保护您填写的所有信息",
    "k_900010": "《隐私声明》",
    "k_900011": "请输入协议名称",
    "k_900012": "添加隐私协议会超出预览字数，请删减后再添加",
    "k_900013": "《隐私声明2》",
    "k_900014": "{0}和{1}",
    "k_900015": "{0}和",
    "k_900016": "和{0}",
    "k_900017": "请输入正确的网址",
    "k_902001": "单选",
    "k_902002": "多选",
    "k_902003": "下载图片",
    "k_902004": "正确率：",
    "k_902005": "共{0}人回答，{1}个选项",
    "k_902008": "选项",
    "k_902009": "百分比",
    "k_902010": "正确答案",
    "k_902011": "选择人数",
    "k_902012": "人数",
    "k_902013": "暂无数据"
  }
};
